import { z } from 'zod';

// Mirror of StagingStatusValues in the API.
export const STAGING_STATUSES = [
  'PENDING',
  'APPROVED',
  'EDITED',
  'REJECTED',
  'SUPERSEDED',
] as const;
export type StagingStatus = (typeof STAGING_STATUSES)[number];

// Mirror of ResolutionStatusValues in the API.
export const RESOLUTION_STATUSES = [
  'RESOLVED',
  'UNMAPPED',
  'AMBIGUOUS',
  'UNSUPPORTED',
] as const;
export type ResolutionStatus = (typeof RESOLUTION_STATUSES)[number];

// ---------- Server response shape (mirror of ObservationStagingDto) ----------

export const stagingRowSchema = z.object({
  id: z.string(),
  documentId: z.string(),
  refCode: z.string(),
  receivedAt: z.string(),

  priceSeriesId: z.string().nullable(),
  cropId: z.string().nullable(),
  cropName: z.string().nullable(),
  varietyId: z.string().nullable(),
  varietyName: z.string().nullable(),
  apmcId: z.string().nullable(),
  apmcName: z.string().nullable(),

  apmcText: z.string().nullable(),
  cropText: z.string().nullable(),
  varietyText: z.string().nullable(),
  gradeText: z.string().nullable(),
  sourceText: z.string().nullable(),

  priceDate: z.string().nullable(), // YYYY-MM-DD
  minPrice: z.number().nullable(),
  modalPrice: z.number().nullable(),
  maxPrice: z.number().nullable(),
  commodityArrivals: z.number().nullable(),
  commodityTraded: z.number().nullable(),
  unit: z.string(),

  resolutionStatus: z.enum(RESOLUTION_STATUSES),
  resolutionCandidates: z.array(z.string()),
  extractionConfidence: z.number().nullable(),
  validationFailures: z.array(z.string()),

  sourcePhotoUrl: z.string().nullable(),
  sourceMimeType: z.string().nullable(),

  status: z.enum(STAGING_STATUSES),
  reviewedBy: z.string().nullable(),
  reviewedAt: z.string().nullable(),
  observationId: z.string().nullable(),
  rejectReason: z.string().nullable(),

  createdAt: z.string(),
  updatedAt: z.string(),
});
export type StagingRow = z.infer<typeof stagingRowSchema>;

// ---------- List query params ----------

export const STAGING_SORT_KEYS = ['received', 'priceDate', 'confidence'] as const;
export type StagingSortKey = (typeof STAGING_SORT_KEYS)[number];
export type SortDirection = 'asc' | 'desc';

export interface ListStagingParams {
  page: number;
  pageSize: number;
  date?: string; // YYYY-MM-DD
  status?: StagingStatus;
  /** Comma-separated status set (e.g. "APPROVED,EDITED"); wins over `status`. */
  statuses?: string;
  resolutionStatus?: ResolutionStatus;
  cropId?: number;
  apmcId?: number;
  varietyId?: number;
  sortBy?: StagingSortKey;
  sortDir?: SortDirection;
}
